import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/meeting/arrange/info/page',
    add:'/api-ir/meeting/arrange/apply',
    reservationList:'/api-ir/meeting/arrange/reservation/',
    approve:'/api-ir/meeting/arrange/approve',
    del:'/api-ir/meeting/arrange/apply/',
    meetingRoomInfo:'/api-ir/meeting/arrange/room/',
    cancel:'/api-ir/meeting/arrange/cancel/',
    batchApprove:'/api-ir/meeting/arrange/batch/'
}
// 查询会议室列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增会议室申请
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 查询会议室申请列表
export function reservationList (id,params) {
    return baseAPI.axiosData(api.reservationList+id+'?'+params,'get')
}
// 会议室申请审批
export function approve (data) {
    return baseAPI.axiosData(api.approve,'post',data)
}

// 新增会议室申请
export function edit (data) {
    return baseAPI.axiosData(api.add,'put',data)
}

// 新增会议室申请
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}

// 新增会议室申请
export function meetingRoomInfo (id) {
    return baseAPI.axiosData(api.meetingRoomInfo+id,'get')
}

export function cancel (id) {
    return baseAPI.axiosData(api.cancel+id,'post')
}

// 会议室申请批量审批
export function batchApprove (operation,data) {
    return baseAPI.axiosData(api.batchApprove+operation,'post',data)
}
